import * as password from './_password';
import * as permission from './_permission';
import * as profile from './_profile';

/** Auth logic. */
const authLogic = {
  password,
  profile,
  permission,
};

export default authLogic;
